__turbopack_context__.v({
  "backgroundContainer": "BackgroundImage-module-scss-module__SdkRQG__backgroundContainer",
});
